import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@celum/authentication';
import { CelumPropertiesProvider } from '@celum/core';

/**
 * Allows access to /request-access/:portalSlug only when navigation was initiated
 * by the app (PortalsAuthGuard passes state.fromApp = true).
 * Direct URL access is blocked → not-found.
 */
export const requestAccessPortalExistsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const navigation = router.getCurrentNavigation();

  if (navigation?.extras?.state?.fromApp === true) {
    authService.setLogoutRedirectUriFallback(`${CelumPropertiesProvider.properties.authentication.logoutRedirectUri}/${navigation.extras.state.portalSlug}`);
    return true;
  }

  router.navigateByUrl('not-found', { skipLocationChange: true });
  return false;
};
